import Reflux from 'reflux'
export default Reflux.createActions(['updateSortDirection','gridHeaderClickSort','autoFormLookupGridHeaderClickSort']);


// WEBPACK FOOTER //
// ./src/actions/QueryActions.js